import React, { ForwardedRef } from 'react';
import {
  Animated,
  FlatList as RNFlatList,
  FlatListProps,
} from 'react-native';
import { SxProp } from 'dripsy';

import { useSxProp } from '@hooks';

export type FlatListRefType = RNFlatList | null;

export interface IFlatListProps<TItem> extends FlatListProps<TItem> {
  animated?: boolean;
  contentContainerSx?: SxProp;
  ListFooterComponentSx?: SxProp;
  listRef?: ForwardedRef<FlatListRefType>;
}

export function FlatList<TItem = any>(props: IFlatListProps<TItem>) {
  const contentContainerStyle = useSxProp({
    styleProp: props.contentContainerStyle,
    sxProp: props.contentContainerSx,
  });
  const ListFooterComponentStyle = useSxProp({
    styleProp: props.ListFooterComponentStyle,
    sxProp: props.ListFooterComponentSx,
  });

  // This helps us avoid inverting ListEmptyComponent
  // when inverted is set to true
  const inverted = props.inverted && !!props.data?.length;

  if (props.animated) {
    return (
      <Animated.FlatList
        {...props}
        inverted={inverted}
        ref={props.listRef}
        data={props.data as Animated.WithAnimatedValue<TItem>[]}
        contentContainerStyle={contentContainerStyle}
        ListFooterComponentStyle={ListFooterComponentStyle}
      />
    );
  }

  return (
    <RNFlatList
      {...props}
      inverted={inverted}
      ref={props.listRef}
      data={props.data}
      contentContainerStyle={contentContainerStyle}
      ListFooterComponentStyle={ListFooterComponentStyle}
    />
  );
}
